module.exports = __webpack_public_path__ + "static/media/HK.58dcdd99.svg";